const players = [
    { name: 'Lebron James', path: 'lebron', price: 6, visibility: true },
    { name: 'Kobe Bryant', path: 'kobe', price: 6 , visibility: true},
    { name: 'Kevin Durant', path: 'kevin', price: 6, visibility: true },
    { name: 'Michael Jordan', path: 'michael', price: 6, visibility: true },
    { name: "Shaquille O'Neal", path: 'shaq', price: 6, visibility: true },
    { name: 'Stephen Curry', path: 'curry', price: 6, visibility: true },
    { name: 'Tim Duncan', path: 'tim', price: 6, visibility: true },
    { name: 'Kareem A. Jabbar', path: 'kareem', price: 6, visibility: true },
    { name: 'James Harden', path: 'harden', price: 5 , visibility: true},
    { name: "Dwight Howard", path: 'dwight', price: 5, visibility: true },
    { name: 'Giannis Akumpo', path: 'giannis', price: 5, visibility: true },
    { name: "Derrick Rose", path: 'rose', price: 5, visibility: true },
    { name: 'Bradley Beal', path: 'beal', price: 4, visibility: true },
    { name: 'Klay Thompson', path: 'klay', price: 4, visibility: true },
    { name: 'Kyrie Irving', path: 'kyrie', price: 4, visibility: true },
    { name: "Jayson Tatum", path: 'tatum', price: 4, visibility: true },
    { name: "Carmelo Anthony", path: 'melo', price: 4, visibility: true },
    { name: "Blake Griffin", path: 'blake', price: 4, visibility: true },
    { name: "Dennis Schröder", path: 'dennis', price: 3, visibility: true },
    { name: "Patrick Mills", path: 'mills', price: 3, visibility: true},
    { name: "Tristan Thompson", path: 'tristan', price: 3, visibility: true },
    { name: "Tyreke Evans", path: 'tyreke', price: 3, visibility: true },
    { name: "JR Smith", path: 'jr', price: 3, visibility: true },
    { name: 'Kyle Kuzma', path: 'kuzma', price: 2, visibility: true },
    { name: 'Nick Young', path: 'nick', price: 2, visibility: true },
    { name: "Larry Nance Jr.", path: 'nance', price: 2, visibility: true },
    { name: "Kelly Oubre Jr.", path: 'kelly', price: 2, visibility: true },
    { name: "Lance Stephenson", path: 'lance', price: 2, visibility: true },
    { name: 'Jahlil Okafor', path: 'okafor', price: 1, visibility: true },
    { name: "Iman Shumpert", path: 'shumpert', price: 1, visibility: true },
    { name: "Rakeem Christmas", path: 'rakeem', price: 1, visibility: true },
    { name: 'Marcus Morris', path: 'morris', price: 1, visibility: true },
]

export default players;